import Vue from "vue";
import VueRouter from "vue-router";
import NotFound from "@/views/NotFound.vue";
import MainLayout from "@/layout/MainLayout.vue";
import SubLayout from "@/layout/SubLayout.vue";
import LearnLayout from "@/layout/LearnLayout.vue";
import store from "../store";
import { MessageBox } from "element-ui";
import { initJQueryPlugins } from "@/utils";

Vue.prototype.$alert = MessageBox.alert;

const router = new VueRouter({
  mode: "history",
  base: process.env.VUE_APP_BASE_PATH || "/usr",
  routes: [
    {
      name: "Main",
      path: "/",
      component: () => import("@/views/Main.vue"),
    },
    {
      name: "main",
      path: "/main",
      meta: { layout: MainLayout },
      component: () => import("@/views/Main.vue"),
    },
    {
      name: "session",
      path: "/session",
      meta: { layout: MainLayout },
      component: () => import("@/views/Session.vue"),
    },
    {
      name: "crse",
      path: "/crse",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/crse/Crse.vue"),
    },
    {
      name: "crseLaw",
      path: "/crse/law",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/crse/CrseLaw.vue"),
    },
    {
      name: "crseList",
      path: "/crse/:categoryNo",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/crse/Crse.vue"),
    },
    {
      name: "enrollIntro",
      path: "/enroll/intro",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/enroll/EnrollIntro.vue"),
    },
    {
      name: "enrollList",
      path: "/enroll/step1/:categoryNo",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/enroll/EnrollStep1.vue"),
    },
    {
      name: "enrollList",
      path: "/enroll/step2/:categoryNo",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/enroll/EnrollStep2.vue"),
    },
    {
      name: "enrollForm",
      path: "/enroll/form/:seqCd",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollForm.vue"),
    },
    {
      name: "enrollForm1",
      path: "/enroll/form1/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollForm1.vue"),
    },
    {
      name: "enrollForm2",
      path: "/enroll/form2/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollForm2.vue"),
    },
    {
      name: "enrollForm3",
      path: "/enroll/form3/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollForm3.vue"),
    },
    {
      name: "enrollForm4",
      path: "/enroll/form4/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollForm4.vue"),
    },
    {
      name: "enrollForm31",
      path: "/enroll/form31/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollForm31.vue"),
    },
    {
      name: "enrollForm32",
      path: "/enroll/form32/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollForm32.vue"),
    },
    {
      name: "enrollForm33",
      path: "/enroll/form33/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollForm33.vue"),
    },
    {
      name: "enrollPayForm",
      path: "/enroll/pay/form/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollPayForm.vue"),
    },
    {
      name: "enrollPayView",
      path: "/enroll/pay/view/:enrollNo",
      meta: { layout: SubLayout, requiresAuth: true },
      props: true,
      component: () => import("@/views/enroll/EnrollPayView.vue"),
    },
    {
      name: "enrollPayTossSuccess",
      path: "/enroll/pay/toss/success",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/enroll/EnrollPayTossSuccess.vue"),
    },
    {
      name: "enrollPayTossFail",
      path: "/enroll/pay/toss/fail",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/enroll/EnrollPayTossFail.vue"),
    },
    {
      name: "myClassList",
      path: "/myclass",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/myclass/MyClass.vue"),
    },
    {
      name: "certList",
      path: "/myclass/cert",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/myclass/CertList.vue"),
    },
    {
      // Q&A 참가자 화면 (QR 링크 · 비로그인 진입 가능)
      name: "qnaUser",
      path: "/qna/:accessKey",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/qna/QnaUser.vue"),
    },
    {
      // 집합교육 출석용 바코드 (안내 문자 링크 · 비로그인 진입 가능)
      name: "enrollQr",
      path: "/enroll/qr/:enrollNo",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/enroll/EnrollQr.vue"),
    },
    {
      // 설문 참여 안내 (비로그인 진입 가능 · 로그인 시 수강번호로 설문 화면 이동)
      name: "myClassSurveyList",
      path: "/myclass/survey/:seqCd",
      meta: { layout: SubLayout },
      props: true,
      component: () => import("@/views/myclass/SurveyList.vue"),
    },
    {
      name: "enrollChangeCeoList",
      path: "/enroll/change/ceo",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/enroll/EnrollChangeCeoList.vue"),
    },
    {
      name: "enrollChangeApplyList",
      path: "/enroll/change/apply",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/enroll/EnrollChangeApplyList.vue"),
    },
    {
      name: "agentList",
      path: "/myclass/agent",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/myclass/AgentList.vue"),
    },
    {
      name: "receiptList",
      path: "/myclass/receipt",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/myclass/ReceiptList.vue"),
    },
    {
      name: "learnMain",
      path: "/learn/main/:enrollNo",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnMain.vue"),
    },
    {
      name: "learnLesson",
      path: "/learn/lesson/:enrollNo",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnLesson.vue"),
    },
    {
      name: "learnLessonView",
      path: "/learn/lesson/:enrollNo/:lessonSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnLessonView.vue"),
    },
    {
      name: "learnExam",
      path: "/learn/exam/list/:enrollNo",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnExamList.vue"),
    },
    {
      name: "learnExamView",
      path: "/learn/exam/view/:enrollNo/:paperSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnExamView.vue"),
    },
    {
      name: "learnExamForm",
      path: "/learn/exam/form/:enrollNo/:paperSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnExamForm.vue"),
    },
    {
      name: "learnNotice",
      path: "/learn/bbs/:enrollNo/:boardSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnBbs.vue"),
    },
    {
      name: "learnNoticeView",
      path: "/learn/bbs/:enrollNo/:boardSeqno/:postsSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnBbsView.vue"),
    },
    {
      name: "learnOff",
      path: "/learn/off",
      meta: { layout: SubLayout },
      component: () => import("@/views/learn/LearnOff.vue"),
    },
    {
      name: "learnSurvey",
      path: "/learn/survey/list/:enrollNo",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnSurveyList.vue"),
    },
    {
      name: "learnSurveyView",
      path: "/learn/survey/view/:enrollNo/:paperSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnSurveyView.vue"),
    },
    {
      name: "learnSurveyForm",
      path: "/learn/survey/form/:enrollNo/:paperSeqno",
      meta: { layout: LearnLayout, requiresAuth: true },
      component: () => import("@/views/learn/LearnSurveyForm.vue"),
    },
    {
      name: "enrollSearch",
      path: "/enroll/search",
      meta: { layout: SubLayout },
      component: () => import("@/views/enroll/EnrollSearchList.vue"),
    },
    {
      name: "bbsList",
      path: "/bbs/:boardSeqno",
      meta: { layout: SubLayout },
      component: () => import("@/views/bbs/Bbs.vue"),
    },
    {
      name: "faqList",
      path: "/bbs/faq/:boardSeqno",
      meta: { layout: SubLayout },
      component: () => import("@/views/bbs/Faq.vue"),
    },
    {
      name: "bbsForm",
      path: "/bbs/:boardSeqno/form",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/bbs/BbsForm.vue"),
    },
    {
      name: "bbsView",
      path: "/bbs/:boardSeqno/:postsSeqno",
      meta: { layout: SubLayout },
      component: () => import("@/views/bbs/BbsView.vue"),
    },
    {
      name: "bbsUpdateForm",
      path: "/bbs/:boardSeqno/:postsSeqno/:cmd",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/bbs/BbsForm.vue"),
    },
    {
      name: "bbsReplyForm",
      path: "/bbs/:boardSeqno/:postsSeqno/reply",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/bbs/BbsForm.vue"),
    },
    {
      name: "myPage",
      path: "/mypage",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/mypage/MyPage.vue"),
    },
    {
      name: "myPageInfo",
      path: "/mypage/info",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/mypage/MyPageInfo.vue"),
    },
    {
      name: "myPagePwd",
      path: "/mypage/pwd",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/mypage/MyPageInfoPwd.vue"),
    },
    {
      name: "myPageLeave",
      path: "/mypage/leave",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/mypage/MyPageInfoLeave.vue"),
    },
    {
      name: "compPromoIntro",
      path: "/comp/promo/intro",
      meta: { layout: SubLayout },
      component: () => import("@/views/comp/CompPromoIntro.vue"),
    },
    {
      name: "compPromoList",
      path: "/comp/promo",
      meta: { layout: SubLayout },
      component: () => import("@/views/comp/CompPromoList.vue"),
    },
    {
      name: "compPromoForm",
      path: "/comp/promo/form",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/comp/CompPromoForm.vue"),
    },
    {
      name: "compPromoRegister",
      path: "/comp/promo/register",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/comp/CompPromoRegister.vue"),
    },
    {
      name: "compPromoUpdateForm",
      path: "/comp/promo/form/:promoSeqno",
      meta: { layout: SubLayout, requiresAuth: true },
      component: () => import("@/views/comp/CompPromoForm.vue"),
    },
    {
      name: "compPromoView",
      path: "/comp/promo/:promoSeqno",
      meta: { layout: SubLayout },
      component: () => import("@/views/comp/CompPromoView.vue"),
    },
    {
      name: "loginForm",
      path: "/login",
      meta: { layout: SubLayout },
      component: () => import("@/views/login/LoginForm.vue"),
    },
    {
      name: "loginLockForm",
      path: "/login/lock",
      meta: { layout: SubLayout },
      component: () => import("@/views/login/LoginLockForm.vue"),
    },
    {
      name: "loginPwdExpireForm",
      path: "/login/pwdexpire",
      meta: { layout: SubLayout },
      component: () => import("@/views/login/LoginPwdExpireForm.vue"),
    },
    {
      name: "findForm",
      path: "/login/find",
      meta: { layout: SubLayout },
      component: () => import("@/views/login/FindForm.vue"),
    },
    {
      name: "signupTermForm",
      path: "/signup/term",
      meta: { layout: SubLayout },
      component: () => import("@/views/signup/SignUpTerm.vue"),
    },
    {
      name: "signupForm",
      path: "/signup/form",
      meta: { layout: SubLayout },
      component: () => import("@/views/signup/SignUpForm.vue"),
    },
    {
      name: "signupSnsForm",
      path: "/signup/snsform",
      meta: { layout: SubLayout },
      component: () => import("@/views/signup/SignUpSnsForm.vue"),
    },
    {
      name: "signupComplete",
      path: "/signup/complete",
      meta: { layout: SubLayout },
      component: () => import("@/views/signup/SignUpComplete.vue"),
    },
    {
      name: "intro",
      path: "/intro/intro",
      meta: { layout: SubLayout },
      component: () => import("@/views/intro/Intro.vue"),
    },
    {
      name: "privacyIntro",
      path: "/intro/privacy",
      meta: { layout: SubLayout },
      component: () => import("@/views/intro/Privacy.vue"),
    },
    {
      name: "emailPrivacy",
      path: "/intro/emailprivacy",
      meta: { layout: SubLayout },
      component: () => import("@/views/intro/EmailPrivacy.vue"),
    },
    {
      name: "legalIntro",
      path: "/intro/legal",
      meta: { layout: SubLayout },
      component: () => import("@/views/intro/Legal.vue"),
    },
    {
      path: "*",
      component: NotFound,
    },
  ],
});

router.afterEach((to) => {
  // One canonical owner; omit query strings and private application routes.
  const path = to.path === "/" ? "/main" : to.path;
  const publicPaths = ["/main", "/enroll/intro", "/enroll/step1/1001", "/enroll/step1/1002", "/enroll/step1/1010", "/enroll/step1/1013"];
  let canonical = document.getElementById("education-canonical");
  if (!publicPaths.includes(path)) {
    if (canonical) canonical.remove();
    return;
  }
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.id = "education-canonical";
    canonical.rel = "canonical";
    document.head.appendChild(canonical);
  }
  // 메인의 대표 주소는 루트다. 서버(EDUCATION_PAGES)·sitemap 과 같은 값을 써야 한다.
  canonical.href = path === "/main" ? "https://edu.khff.or.kr/" : "https://edu.khff.or.kr/usr" + path;
});

router.afterEach((to, from) => {
  // navercts
  if (!window.wcs_add) window.wcs_add = {};
  window.wcs_add.wa = "s_3fd2e54c4601";
  if (!_nasa) var _nasa = {};
  if (window.wcs) {
    wcs.inflow();
    wcs_do();
  }
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth) && store.getters.currentUser?.userId == null) {
    localStorage.setItem("referer", to.fullPath);

    console.log("referer", localStorage.getItem("referer"));
    //store.dispatch("setSessionScope", { referer: to.path });
    next({ name: "loginForm" });
    // Vue.prototype.$alert("로그인이 필요한 서비스 입니다.<br>로그인 후 이용해 주세요.", "안내", {
    //   confirmButtonText: "확인",
    //   dangerouslyUseHTMLString: true,
    //   callback: (action) => {
    //     next({ name: "loginForm" });
    //   },
    // });
  } else next();
});
router.onError((error) => {
  console.log("router error :", error, navigator.onLine);
  if (/ChunkLoadError/i.test(error) && navigator.onLine) {
    window.location.reload();
  }
});

// 페이지 이동 후 jQuery 플러그인 재초기화
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    // jQuery 플러그인이 로드될 때까지 대기
    if (window.jQueryPluginsLoaded) {
      initJQueryPlugins();
    } else {
      // 로드되지 않았다면 최대 3초 동안 100ms마다 체크
      let attempts = 0;
      const checkInterval = setInterval(() => {
        attempts++;
        if (window.jQueryPluginsLoaded || attempts > 30) {
          clearInterval(checkInterval);
          if (window.jQueryPluginsLoaded) {
            initJQueryPlugins();
          }
        }
      }, 100);
    }
  });
});

export default router;
